import React from 'react';
import { Box, Typography } from '../../../design-system';
import { colors } from '../../../design-system/colors';

interface TabEmptyStateProps {
  message: string;
}

/**
 * Empty state display for tab content
 */
const TabEmptyState: React.FC<TabEmptyStateProps> = ({ message }): JSX.Element => (
  <Box
    sx={{
      backgroundColor: colors.card.contentBackground,
      borderRadius: '16px',
      padding: '32px',
      minHeight: '400px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography
      variant="body"
      color="white"
      sx={{
        fontSize: '16px',
        fontFamily: 'Outfit, sans-serif',
        fontWeight: 400,
        color: colors.neutral[600],
        textAlign: 'center',
      }}
    >
      {message}
    </Typography>
  </Box>
);

export default TabEmptyState;
